import React from 'react';
import {
    Badge,
    Tab,
    Tabs,
} from '@material-ui/core';
import {
    isEmpty,
} from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import ItemDetail from './itemDetail';
import ItemProduct from './itemProduct';
import ItemDeliveryNote from './itemDeliveryNote';
import ItemChildren from './itemChildren';

const styles = (theme) => ({
    badge: {
        verticalAlign: 'middle',
        marginLeft: 16,
        marginBottom: 3,
    },
    badgeContent: {
        paddingTop: 1,
    },
    tabs: {
        marginTop: theme.spacing.unit * 3,
    },
});

class ItemTabs extends React.Component {
    state = {
        currentTab: 0,
    };

    componentDidMount() {
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.contact !== prevProps.contact) {
    //         this.setupFormData();
    //     }
    // }

    handleTabChange = (event, value) => {
        this.setState({
            currentTab: value,
        });
    };

    render() {
        const {
            classes,
            fetchHistoriesData,
            fetchItemData,
            item,
            itemLoading,
            itemHistoriesLoading,
            itemChildrenLoading,
            user,
        } = this.props;
        const {
            currentTab,
        } = this.state;

        // let tabs = [];

        const tabs = [
            {
                disabled: false,
                label: 'DETAILS',
                key: 'details',
            },
            {
                disabled: false,
                label: 'PRODUCT',
                key: 'product',
            },
            {
                disabled: (item ? (item.children || []).length === 0 : true),
                label: 'CHILD ITEMS',
                key: 'childItems',
            },
            {
                disabled: !(item ? item.deliveryNoteCode : true),
                label: 'DELIVERY NOTE',
                key: 'deliveryNote',
            },
        ];

        return (
            <>
                <Tabs
                    className={classes.tabs}
                    value={currentTab}
                    onChange={this.handleTabChange}
                >
                    {tabs.map((tab) => (
                        <Tab
                            key={tab.label}
                            label={(
                                <>
                                    {tab.label}
                                    {/* {' '}
                                    {!contactLoading
                                        && (
                                            (tab.label === 'DEBT' && contact.debt && contact.debt.status !== 'NORMAL')
                                            || (tab.label === 'DUPLICATES' && contact.duplicates.length > 0)
                                            || (tab.label === 'COMPLAINTS' && contact.complaints.filter((complaint) => complaint.status === 'OPEN').length > 0)
                                            || (tab.label === 'DETAILS' && isEmpty(contact.address))
                                        )
                                        && (
                                            <FontAwesomeIcon icon={faExclamationTriangle} color="red" className={classes.WarningIcon} />
                                        )} */}
                                </>
                            )}
                            disabled={itemLoading || tab.disabled}
                        />
                    ))}
                </Tabs>
                <>
                    { tabs[currentTab].label === 'DETAILS'
                        ? (
                            <>
                                <ItemDetail
                                    fetchItemData={fetchItemData}
                                    item={item}
                                    itemLoading={itemLoading}
                                    itemHistoriesLoading={itemHistoriesLoading}
                                    user={user}
                                />
                            </>
                        )
                        : null}
                    { tabs[currentTab].label === 'PRODUCT'
                        ? (
                            <>
                                <ItemProduct
                                    fetchItemData={fetchItemData}
                                    item={item}
                                    itemLoading={itemLoading}
                                    itemHistoriesLoading={itemHistoriesLoading}
                                    user={user}
                                />
                            </>
                        )
                        : null}
                    { tabs[currentTab].label === 'CHILD ITEMS'
                        ? (
                            <>
                                <ItemChildren
                                    fetchItemData={fetchItemData}
                                    item={item}
                                    itemLoading={itemLoading}
                                    itemHistoriesLoading={itemHistoriesLoading}
                                    itemChildrenLoading={itemChildrenLoading}
                                />
                            </>
                        )
                        : null}
                    { tabs[currentTab].label === 'DELIVERY NOTE'
                        ? (
                            <>
                                <ItemDeliveryNote
                                    fetchItemData={fetchItemData}
                                    item={item}
                                    itemLoading={itemLoading}
                                    itemHistoriesLoading={itemHistoriesLoading}
                                />
                            </>
                        )
                        : null}
                </>
            </>
        );
    }
}

export default withStyles(styles)(ItemTabs);
